module.exports = __webpack_public_path__ + "de0bc82162e147ea4c88eb2ce38de469.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-420.webp.png
// module id = 431
// module chunks = 0